import React, { useEffect } from "react";
import Button from "../../component/button/Button";
import Image from "../../component/image/Image";
// import Vector from "../../assets/images/Vector_1.png";
import "../../styles/pages/welcome.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { complianceTeamConfig, getCandidateData, loderControl, updateUserData } from "../../redux/slices/newRoleSlices";
import { toast } from "react-toastify";
import Loader from "../../component/loader/Loader";
import { persistor } from "../../redux/store";
import { domainWithHttp } from "../../config/onboarding/onBoarding";

const WelcomeScreen = () => {
    const dispatch = useDispatch();

    const candidateData = useSelector((state: any) => { return state?.newRole?.candidateData; });
    const loader = useSelector((state: any) => { return state?.newRole?.loading; });

    const navicate = useNavigate();
    const { clientId } = useParams();

    useEffect(() => {

        // reseting the local storage when loading onboarding page
        localStorage.removeItem("clindFirstName");
        localStorage.removeItem("newCandidateName");

    //     const getToken = async () => {

            // dispatch<any>(removeCandidateData());
            persistor.flush().then(() => {
                return persistor.purge();
            });
            dispatch<any>(loderControl());
    

                if (clientId) {
                    sessionStorage.removeItem("navigateTo");
                    const obj:any ={};
                    obj["clientId"] = clientId;
                    obj["domainWithHttp"] = domainWithHttp;
                    dispatch<any>(getCandidateData(obj)).then((action: any) => {
                        const data = action?.payload?.data;
                        if (data?.maintenance) {
                            navicate("/getCandidate/maintenance", { state: { clientLogo: data.clientLogo } });
                        }
                    });

                    dispatch<any>(complianceTeamConfig(`/${clientId}`));
                    sessionStorage.setItem("clientId", clientId);
                }
    //         }
    //     };
    //     getToken();
    //     // persistor.flush().then(() => {
    //     //     return persistor.purge();
    //     // });
    }, []);




    useEffect(() => {

        if (candidateData?.statusCode === 200) {
            // document.documentElement.style.setProperty("--primary-color", candidateData?.clientDetails?.brandColor);

            // return;
            if (candidateData.currentPage === -2 || candidateData.currentPage === "-2") {
                // console.log(candidateData);
                dispatch(loderControl());
                navicate("/getCandidate/onboarding-result");
            } else if (candidateData.currentPage === "-1" || candidateData.currentPage === -1) {
                console.log();
                // setTimeout(() => {
                //     dispatch(loderOffControl());
                // }, 5000);
            } else {
                dispatch(loderControl());
                navicate("/getCandidate/onboarding");

            }

        } else if (candidateData?.status === 400) {
            navicate("*");
            toast(candidateData?.data?.message, {
                type: "error"
            });
        } else {
            // console.log(candidateData);

        }
    }, [candidateData]);
    const moveToNextPage = () => {
        const params = { ...candidateData };
        params.currentPage = 1;
        dispatch(updateUserData(params));
        // navicate("/getCandidate/onboarding");
    };

    const clientDetails = candidateData?.clientDetails;
    const candidateFirstName = candidateData?.candidateDetails?.firstName;
    const logoUrl = clientDetails?.logo;
    const videoUrl = clientDetails?.videoUrl?.trim();
    const imageUrl = clientDetails?.imageUrl?.trim();
    const hasVideo = Boolean(videoUrl);
    const hasImage = Boolean(imageUrl);
    const hasMedia = hasVideo || hasImage;
    const logoWidth = clientDetails?.titleTabText === "Mitsubishi" ? 300 : undefined;
    const brandName = clientDetails?.titleTabText || "Client";

    const controlDivElement = () => {
        return (
            <>
                <div className="">
                    <p className="text-primary welcome-text"> <span>{candidateFirstName}</span>, {clientDetails?.introPageTitleText}
                    </p>
                    <div className="welcome-one" dangerouslySetInnerHTML={{ __html: clientDetails?.description }}>

                    </div>
                </div>
                <div className="mb-3">
                    <Button label={clientDetails?.introPageButtonText} icon="pi pi-arrow-right" position="right" onClick={() => moveToNextPage()} type="button" clasName="btn btn-primary" />
                </div>
            </>
        );
    };

    return (
        <>
            <div>
                <Loader loading={loader} />
            </div>
            {candidateData?.statusCode === 200 ?
                <div className="container">
                    <div className="welcome-video-section">
                        <div className="welcome-video-section-left">
                            <div className="d-flex">
                                <div className={hasVideo ? "video-section" : "image-section"}>
                                    <Image
                                        src={logoUrl}
                                        alt={`${brandName} logo`}
                                        clasName="img-fluid"
                                        width={logoWidth}
                                    />
                                </div>
                            </div>
                            {hasMedia ?
                                controlDivElement()
                                :
                                ""
                            }

                        </div>
                        <div className="welcome-video-section-right">
                            {hasMedia ?
                                <>
                                    {hasVideo && (
                                        <div className="welcome-media-panel welcome-media-panel-video">
                                            <video
                                                controls
                                                preload="metadata"
                                                width="100%"
                                                src={videoUrl}
                                                className="border w-100"
                                            />
                                        </div>
                                    )}
                                    {!hasVideo && hasImage && (
                                        <div className="welcome-media-panel welcome-media-panel-image">
                                            <Image
                                                src={imageUrl}
                                                alt={`${brandName} welcome`}
                                                clasName="img-fluid welcome-media-image"
                                            />
                                        </div>
                                    )}
                                </>
                                :
                                controlDivElement()

                            }
                        </div>
                    </div>
                </div >
                :
                <>
                    {candidateData?.message ?
                        <div className="row justify-content-center align-item-center">
                            <div className="col-md-5">
                                <div className="mt-5 pt-5">
                                    <div className="alert alert-danger" role="alert">
                                        {candidateData?.message}
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="row justify-content-center align-item-center">
                            <div className="col-md-5">
                                <div className="mt-5 pt-5">
                                    <div className="alert alert-danger text-center" role="alert">
                                        <p>This is not a valid onboarding link. Either the link is expired or invalid.</p>
                                        <p>Please contact support team for assistance.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </>

            }
        </>
    );
};
export default WelcomeScreen;
